window.SiteHeader = window.SiteHeader || {};

window.SiteHeader.AGAModeSelector = (function ($, Behaviors, FLBuilderSearchForm) {
    "use strict";

    function AGAModeSelector() {
        Behaviors.init(AGAModeSelector, this, arguments);

        this.original_classes = this.$elem.attr("class");
        this.is_scrolled = $(window).scrollTop() > 0;
        this.is_search_opened = false;
        this.is_mobile_opened = false;

        this.scroll_intent();
        $(window).on("scroll", this.scroll_intent.bind(this));

        this.$elem.find("form[role='search']").append($("<button type='submit'><i class='fl-button-icon fl-button-icon-before ua-icon ua-icon-arrow-right2' aria-hidden='true'></i></button>"));
        this.$elem.find("form[role='search']").each(function() {
            this.setAttribute('action', '/'); /* https://landloans.agamerica.com/s/767343/WZHG0bDZrqZZUanCkhqjBpWYVNRozPip */
        });
    }

    Behaviors.inherit(AGAModeSelector, Behaviors.Behavior);

    AGAModeSelector.QUERY = "[data-agamenu-modeselector]";

    /**
     * Primary mechanism by which updates to mode selector state update the UI.
     * 
     * Always call this function when state changes.
     */
    AGAModeSelector.prototype.update_classes = function () {
        if (this.is_scrolled || this.is_mobile_opened || this.is_search_opened) {
            this.$elem.attr("class", "SiteHeader-aga_light_mode SiteHeader-aga_solid");
        } else {
            this.$elem.attr("class", this.original_classes);
        }
    }

    AGAModeSelector.prototype.scroll_intent = function(evt) {
        this.is_scrolled = $(window).scrollTop() > 0;
        this.update_classes();
    }

    AGAModeSelector.prototype.mobile_menu_opened = function () {
        this.is_mobile_opened = true;
        this.update_classes();
    }

    AGAModeSelector.prototype.mobile_menu_closed = function () {
        this.is_mobile_opened = false;
        this.update_classes();
    }

    AGAModeSelector.prototype.mobile_search_menu_toggle = function (is_search_opened) {
        this.is_search_opened = is_search_opened;
        this.update_classes();
    }

    Behaviors.register_behavior(AGAModeSelector);

    if (window.FLBuilderSearchForm !== undefined) {
        /**
         * Override the click event handler on the search form so that our event
         * handlers can run.
         */
        window.FLBuilderSearchForm.prototype._buttonClick = function(e) {
            if (this.searchForm.hasClass('fl-search-button-expand')) {
                this.searchForm.find('.fl-search-form-wrap').toggleClass('fl-search-expanded');

                if (this.searchForm.find('.fl-search-form-wrap').hasClass('fl-search-expanded')) {
                    AGAModeSelector.locate($(AGAModeSelector.QUERY)).mobile_search_menu_toggle(true);
                    this.input.focus();
                }
                else {
                    AGAModeSelector.locate($(AGAModeSelector.QUERY)).mobile_search_menu_toggle(false);
                    this._hideResults();
                }

                return false;
            } else {
                this._search(e);
            }
        }
    }

    return AGAModeSelector;
}(window.jQuery, window.Behaviors, window.FLBuilderSearchForm));